<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="Herramientas" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                        <template slot="header">
                            <th :class="StyleTh+' text-center'">#</th>
                            <th :class="StyleTh">Elegir</th>
                            <th :class="StyleTh">Nombre</th>
                            <th :class="StyleTh">Stock</th>
                            <th :class="StyleTh">Cantidad de Salida</th>
                        </template>

                        <template slot="body">
                            <tr v-for="(lista,index) in Herramientas" :key="index">
                                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                                <td>
                                    <div class="form-check">
                                        <input type="checkbox" v-model="lista.Check" @change="AgregarQuitarCheck(lista)" :id="'chk'+index" class="form-check-input">
                                        <label class="form-check-label" :for="'chk'+index">
                                        </label>
                                    </div>
                                </td>
                                <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                <td><p :class="StyleTd">{{ lista.Stock }}</p></td>
                                <td>
                                    <input :disabled="lista.Disabled" type="text" class="form-control" v-model="lista.CantidadSalida" @input="$onlyNums($event,lista,'CantidadSalida');CalculaStock(lista)">
                                </td>
                            </tr>
                        </template>
                    </CList>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name:'SeleccionHerramientas',
    props:['poBtnSave','pObjSolicitudAlmacen'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'Herramientas',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: false,
                ShowFooter:false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                Cantidad:1
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjSolicitudAlmacen:{},
            Herramientas:[],
            HerramientasCheck:[]
        }
    },
    methods: {
        Recuperar()
        {
            this.ConfigList.ShowLoader=true;
            this.$http.get('materiales',
            {
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    Stock: this.Filtro.Cantidad,
                    TipoMaterial: 'Herramienta',
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;

                res.data.data.data.forEach((element)=>{
                    element.Check = false;
                    element.CantidadSalida = "0";
                    element.Disabled = true;
                });

                if (this.ObjSolicitudAlmacen.Herramientas.length>0)
                {
                    res.data.data.data.forEach((element)=>{
                        let index=this.ObjSolicitudAlmacen.Herramientas.findIndex((element2)=>element2.IdMaterial == element.IdMaterial);
                        // console.log(index);
                        if (index!=-1) {
                            element.Check = true;
                            element.CantidadSalida = this.ObjSolicitudAlmacen.Herramientas[index].CantidadSalida;
                            element.Disabled = false;
                            this.HerramientasCheck.push(element);
                        }
                    });
                }

                if (this.HerramientasCheck.length>0)
                {
                    this.HerramientasCheck.forEach((element)=>{
                        let index = res.data.data.data.findIndex((element2)=>element2.IdMaterial == element.IdMaterial);
                        if (index!=-1) {
                            res.data.data.data[index].Check = true;
                            res.data.data.data[index].CantidadSalida = element.CantidadSalida;
                            res.data.data.data[index].Disabled = element.Disabled;
                        }
                    })
                }
                this.Herramientas = res.data.data.data;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
                this.ConfigLoad.ShowLoader = false;
            });
        },
        // Limpiar(){
        //     this.HerramientasCheck=[];
        // },
        SeleccionHerramienta(item){
            this.bus.$emit('AgregarHerramientaModal',item)
        },
        AgregarQuitarCheck(item)
        {
            if (item.Check) {
                item.CantidadSalida = "0";
                item.Disabled = false;
                this.HerramientasCheck.push(item);
            }
            else{
                item.Disabled = true;
                let index = this.HerramientasCheck.findIndex((element)=>item.IdMaterial == element.IdMaterial);
                this.HerramientasCheck.splice(index,1);
            }
        },
        SeleccionHerramientas()
        {
            let BndError = false;
            let Mensaje = "";

            this.Herramientas.every(element=>{
                if (element.Check && element.CantidadSalida==0) {
                    Mensaje = "La Cantidad de la Herramienta " + element.Nombre +" Debe Ser Mayor a 0";
                    BndError = true;
                    return false;
                }
                if (element.Check && element.CantidadSalida>element.Stock) {
                    Mensaje = "La Cantidad de la Herramienta " + element.Nombre +" No Debe Exceder el Stock Disponible";
                    BndError = true;
                    return false;
                }
                return true;
            });
            if (BndError) {
                this.$toast.warning(Mensaje);
                return false;
            }
            this.Herramientas.forEach((item)=>{
                if (item.Check) {
                    let index=this.ObjSolicitudAlmacen.Herramientas.findIndex((element)=>element.IdMaterial == item.IdMaterial);
                    if (index==-1) {
                        this.bus.$emit('AgregarHerramientaModal',item);
                    }
                }
            });
            this.bus.$emit('CloseModal_'+this.Emit);
        },
        CalculaStock(item)
		{
			let Cantidad = item.CantidadSalida;
			let Stock = item.Stock;

			if(Cantidad>Stock){
				item.CantidadSalida = Stock;
			}
		},
    },
    created() {
        this.ObjSolicitudAlmacen = this.pObjSolicitudAlmacen;
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>{
                this.SeleccionHerramientas();
            });
            // this.Limpiar();
            // this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            this.Recuperar();
        });
    },
}
</script>

<style>

</style>